(() => {
  if (customElements.get("header-search")) {
    return;
  }

  class HeaderSearch extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector("[data-search-toggle]");
      this.form = this.querySelector("[data-search-form]");
      this.input = this.querySelector("[data-search-input]");
    }

    connectedCallback() {
      this.toggle?.addEventListener("click", this.open.bind(this));
      this.form?.addEventListener("submit", this.handleSubmit.bind(this));
      document.addEventListener("click", this.handleOutsideClick.bind(this));
      document.addEventListener("keydown", this.handleKeydown.bind(this));
    }

    open(event) {
      if (window.matchMedia("(max-width: 1023px)").matches) {
        const searchUrl = this.toggle?.dataset.searchUrl;

        if (searchUrl) {
          window.location.href = searchUrl;
        }

        return;
      }

      event.preventDefault();
      this.classList.add("is-active");
      this.toggle?.setAttribute("aria-expanded", "true");
      this.input?.focus();
    }

    close() {
      this.classList.remove("is-active");
      this.toggle?.setAttribute("aria-expanded", "false");
    }

    handleSubmit(event) {
      if (!this.input?.value.trim()) {
        event.preventDefault();
        this.input?.focus();
      }
    }

    handleOutsideClick(event) {
      if (!this.classList.contains("is-active") || this.contains(event.target)) {
        return;
      }

      this.close();
    }

    handleKeydown(event) {
      if (event.key === "Escape") {
        this.close();
        this.toggle?.focus();
      }
    }
  }

  customElements.define("header-search", HeaderSearch);
})();
